import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';

export const AgenticCommerceSettingsConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "agenticCommerceSettings" */ '../../../components/AgenticCommerceSettings/AgenticCommerceSettings'
    ),
  htmlEvents: ['onagreementupdated'],
  customHtmlElementMethods: {
    setOnAgreementUpdated: {
      type: 'EventListenerMethod',
      event: 'onagreementupdated',
      isInternal: false,
      description:
        'Sets the event listener that allows a user to pass in a callback function for when an agreeement is updated.',
    },
  },
  releaseState: 'preview',
  sentryTeam: 'connect_marketplaces',
  teamOwner: 'connect-integrations',
  description:
    'Displays settings to manage agentic commerce, including a buttons to enable/disable orchestrated commerce agreements (OCAs) with AI agents.',
  friendlyName: 'Agentic commerce settings',
  enableV2APIToken: true,
};
